import { pollingApi } from 'apiConnector/polling';
import type { Observable } from 'rxjs';

import type { LightweightEvent } from '../model';
import { getNewPollingQueueId } from './queue';
import { startPolling } from './startPolling';

export function initPolling(intervalMs: number): Observable<LightweightEvent> {
  window.pollingQueueId = getNewPollingQueueId();

  return startPolling(intervalMs, pollingApi);
}
